export enum EPermissions {
  Owner = 'owner', // deprecated
  Admin = 'admin',
  Analytics = 'analytics',
  Moderation = 'moderation',
  Producer = 'producer',
  ModeratorRegistrant = 'moderator_registrant', // deprecated
  PasscodeManager = 'passcode_manager', // deprecated
  Editor = 'editor',
  GroupAdmin = 'group_admin',
  Viewer = 'viewer', // not visible in BLP
  Builder = 'builder',
  Presenter = 'presenter', // not visible in BLP
}

export const EPermissionsDisplayNames: { [key in EPermissions]: string } = {
  [EPermissions.Owner]: 'Owner', // deprecated
  [EPermissions.Admin]: 'Admin',
  [EPermissions.Analytics]: 'Analyst',
  [EPermissions.Moderation]: 'Moderator',
  [EPermissions.Producer]: 'Producer',
  [EPermissions.ModeratorRegistrant]: 'Moderator Registrant', // deprecated
  [EPermissions.PasscodeManager]: 'Passcode Manager', // deprecated
  [EPermissions.Editor]: 'Editor',
  [EPermissions.GroupAdmin]: 'Group Manager',
  [EPermissions.Viewer]: 'Viewer', // not visible in BLP
  [EPermissions.Builder]: 'Developer',
  [EPermissions.Presenter]: 'Presenter', // not visible in BLP
};

export const PERMISSIONS: { [key: string]: EPermissions } = {
  Owner: EPermissions.Owner, // deprecated
  Admin: EPermissions.Admin,
  Builder: EPermissions.Builder,
  Editor: EPermissions.Editor,
  GroupAdmin: EPermissions.GroupAdmin,
  Analytics: EPermissions.Analytics,
  Moderation: EPermissions.Moderation,
  Producer: EPermissions.Producer,
  PasscodeManager: EPermissions.PasscodeManager, // deprecated
  ModeratorRegistrant: EPermissions.ModeratorRegistrant, // deprecated
  Viewer: EPermissions.Viewer, // not visible in BLP
  Presenter: EPermissions.Presenter, // not visible in BLP
};

export const VISIBLE_PERMISSIONS: { [key: string]: EPermissions } = {
  Admin: EPermissions.Admin,
  Builder: EPermissions.Builder,
  Editor: EPermissions.Editor,
  GroupAdmin: EPermissions.GroupAdmin,
  Analytics: EPermissions.Analytics,
  Moderation: EPermissions.Moderation,
  Producer: EPermissions.Producer,
};

// Admin, Owner, and builder are added to these in the useHasPermission hook
export const GENERAL_EDITABLE_PERMISSIONS = [EPermissions.GroupAdmin, EPermissions.Editor];
export const ALL_ACCESS = [
  EPermissions.Admin,
  EPermissions.Builder,
  EPermissions.Owner,
  EPermissions.Editor,
  EPermissions.GroupAdmin,
  EPermissions.Analytics,
  EPermissions.Moderation,
  EPermissions.Producer,
  EPermissions.PasscodeManager,
  EPermissions.ModeratorRegistrant,
  EPermissions.Viewer,
  EPermissions.Presenter,
];

export const DEVELOPER_ONLY = [
  EPermissions.Admin,
  EPermissions.Builder,
  EPermissions.Owner,
  EPermissions.Editor,
  EPermissions.GroupAdmin,
];

// expanded access roles for basic navigation (switching channels)
export const expandedAccess = [
  EPermissions.Owner,
  EPermissions.Admin,
  EPermissions.Moderation,
  EPermissions.PasscodeManager,
  EPermissions.Editor,
  EPermissions.GroupAdmin,
  EPermissions.Producer,
  EPermissions.Viewer,
  EPermissions.Analytics,
  EPermissions.Builder,
];

// expanded access roles for basic navigation (switching channels)
export const canAccessAdminConsole = [
  EPermissions.Owner,
  EPermissions.Admin,
  EPermissions.Moderation,
  EPermissions.Editor,
  EPermissions.GroupAdmin,
  EPermissions.Producer,
  EPermissions.Analytics,
  EPermissions.Builder,
];

export const isAdminLevel = [EPermissions.Owner, EPermissions.Admin];

export const isAdminOrBuilder = [...isAdminLevel, EPermissions.Builder];

export const isGroupAdminAndUp = [...isAdminOrBuilder, EPermissions.GroupAdmin];

export const canCreateProjects = [
  EPermissions.Owner,
  EPermissions.Admin,
  EPermissions.GroupAdmin,
  EPermissions.Viewer,
  EPermissions.Builder,
];

export const canAccessContentManager = [
  EPermissions.Owner,
  EPermissions.Admin,
  EPermissions.Editor,
  EPermissions.GroupAdmin,
  EPermissions.Builder,
];

export const canAccessCourses = canAccessContentManager;
export const canModifyCourses = isGroupAdminAndUp;

export const canAccessPeople = [
  EPermissions.Owner,
  EPermissions.Admin,
  EPermissions.PasscodeManager,
  EPermissions.GroupAdmin,
  EPermissions.Builder,
];

export const canAccessAnalytics = [
  EPermissions.Owner,
  EPermissions.Admin,
  EPermissions.Analytics,
  EPermissions.GroupAdmin,
  EPermissions.Builder,
];

export const canAccessProjectDetailsAnalytics = [
  ...canAccessAnalytics,
  EPermissions.Editor,
  EPermissions.Moderation,
  EPermissions.Producer,
];

export const canGenerateContent = [
  EPermissions.Owner,
  EPermissions.Admin,
  EPermissions.GroupAdmin,
  EPermissions.Builder,
  EPermissions.Editor,
  EPermissions.Moderation,
  EPermissions.Producer,
];

export const canAccessModerator = [
  EPermissions.Owner,
  EPermissions.Admin,
  EPermissions.Moderation,
  EPermissions.GroupAdmin,
  EPermissions.Builder,
];

export const canAccessEditor = [
  EPermissions.Owner,
  EPermissions.Admin,
  EPermissions.Editor,
  EPermissions.GroupAdmin,
  EPermissions.Viewer,
  EPermissions.Builder,
];

export const canAccessRtmp = [...canAccessEditor, EPermissions.Producer];
